import { render, staticRenderFns } from "./ride-card-template.vue?vue&type=template&id=753e161b&scoped=true&lang=pug&"
import script from "./ride-card-template.vue?vue&type=script&lang=js&"
export * from "./ride-card-template.vue?vue&type=script&lang=js&"
import style0 from "./ride-card-template.vue?vue&type=style&index=0&id=753e161b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753e161b",
  null
  
)

export default component.exports